<template>
  <div>
    <Spinner v-if="loading" />
    <FormSelect :placeholder="placeholder" :value="categoryId" @input="onCategoryUpdated" :options="stockCategoryLookup" :field="field" v-show="!loading" />  
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'FormStockCategorySelect',
  props: {
    stockType: String,
    value: Number,
    field: String,
    placeholder: String
  },
  data() {
    return {
      loading: false,
      categoryId: parseInt(this.$props.value),
      stockCategoryList: []
    }
  },
  watch: {
    value: function(newVal) {
      this.categoryId = parseInt(this.$props.value)
      this.$emit('input', this.$data.categoryId)
    },
    stockType: function(newVal, oldVal) {

      this.updateSelectedCategory()
    }
  },
  mounted() {
    this.requestStockCategoryList()
  },
  computed: {
    stockCategoryLookup() {
      return this.$data.stockCategoryList.filter(category => {
        return this.$props.stockType == category.stockType
      })
    },
  },
  methods: {
    requestStockCategoryList() {
      this.loading = true

      this.$apiService.inventoryService.getStockCategoryList()
      .then(response => {
        // Format the category list into 2 levels of parents / leaves
        this.buildCategoryTree(response.data)

        this.updateSelectedCategory()
      })
      .catch(err => {
      })
      .finally(() => {
        this.loading = false
      })
    },
    buildCategoryTree(list) {
      var outputTree = []

      list.forEach(category => {
        // If this category has no children, it's a leaf & we'll add it to the list
        let hasChildren = list.filter(child => child.parentCategoryId == category.id).length > 0

        if(!hasChildren) {
          // Generate parent name
          if(category.parentCategoryId) {
            var parentName = this.buildName(list, category.parentCategoryId)
            var outputParent = outputTree.find(treeItem => treeItem.name == parentName && treeItem.stockType == category.stockType && treeItem.children !== undefined)
            if(outputParent) {
              outputParent.children.push({
                name: category.name,
                value: category.id,
              })
            } else {
              outputTree.push({
                name: parentName,
                stockType: category.stockType,
                children: [{
                  name: category.name,
                  value: category.id,
                }]
              })
            }
          } else {
            outputTree.push({
              name: category.name,
              stockType: category.stockType,
              value: category.id
            })
          }
        }
      })

      this.$data.stockCategoryList = outputTree
    },

    buildName(list, categoryId, currentName = '') {
      var cat = list.find(category => category.id == categoryId)
      if(cat) {
        var newName = cat.name
        if(currentName != '')
          newName += ` - ${currentName}`
        return this.buildName(list, cat.parentCategoryId, newName)
      }
      return currentName
    },
    onCategoryUpdated(value) {

      this.categoryId = parseInt(value)
      this.$emit('input', this.$data.categoryId)
    },

    updateSelectedCategory() {
      // Ignore if we don't have data yet
      if(this.stockCategoryLookup.length == 0)
        return

      // If stock category is not in the list, reset it to the first item
      var categoryList = this.stockCategoryLookup
      var foundCat = categoryList.find(option => {
        if(option.value == this.$data.categoryId)
          return true
        if(option.children) {
          if(option.children.find(child => child.value == this.$data.categoryId) != null)
            return true
        }
        return false
      })

      if(!foundCat) {
        this.$data.categoryId = null
        if(!_.isEmpty(categoryList)) {
          // Find first valid child
          categoryList.forEach(category => {
            if(!this.$data.categoryId) {
              if(category.children && category.children.length > 0) {
                this.$data.categoryId = category.children[0].value
              } else {
                this.$data.categoryId = category.value
              }
            }
          })
        }

        this.$emit('input', this.$data.categoryId)
      }
    }
  }
}
</script>